import { DashboardsLoadingView } from '@/views/dashboards/dashboards.loading';

export default DashboardsLoadingView;
